var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuspendFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 31,
    viewBox: "0 0 33 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16913_286226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6499 3.89V20.82C28.0999 20.61 27.5099 20.5 26.8999 20.5C24.1399 20.5 21.8999 22.74 21.8999 25.5C21.8999 26.52 22.1999 27.47 22.7299 28.25H4.2899C3.3899 28.25 2.5299 27.89 1.8899 27.26C1.2599 26.62 0.899902 25.76 0.899902 24.86V3.89C0.899902 2.99 1.2599 2.13 1.8899 1.49C2.5299 0.86 3.3899 0.5 4.2899 0.5H25.2599C26.1599 0.5 27.0199 0.86 27.6599 1.49C28.2899 2.13 28.6499 2.99 28.6499 3.89Z",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4897 10.4099V13.3199H23.7897L23.0997 17.7999H19.4897V28.2599H14.6497V17.7999H10.7197V13.3199H14.6497V9.90988C14.6497 6.01988 16.9697 3.87988 20.5097 3.87988C21.6697 3.89988 22.8197 3.99988 23.9697 4.17988V7.99988H22.0197C21.8597 7.96988 21.6897 7.96988 21.5297 7.97988C20.9397 8.02988 20.3897 8.31988 20.0097 8.77988C19.6297 9.23988 19.4397 9.81988 19.4997 10.4199L19.4897 10.4099Z",
    fill: "var(--mainColor)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4199 21.97L28.6499 23.74L24.1399 28.25L23.3699 29.02C23.1299 28.79 22.9099 28.53 22.7299 28.25C22.1999 27.47 21.8999 26.52 21.8999 25.5C21.8999 22.74 24.1399 20.5 26.8999 20.5C27.5099 20.5 28.0999 20.61 28.6499 20.82C29.3199 21.07 29.9199 21.46 30.4199 21.97Z",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9001 25.4997C31.9001 28.2597 29.6601 30.4997 26.9001 30.4997C25.5201 30.4997 24.2701 29.9397 23.3701 29.0297L24.1401 28.2497L28.6501 23.7397L30.4201 21.9697H30.4301C31.3401 22.8697 31.9001 24.1197 31.9001 25.4997Z",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.37 29.0303L23.21 29.1803",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5797 21.8096L30.4297 21.9696",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16913_286226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 31,
    fill: "white",
    transform: "translate(0.399902)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuspendFacebook);
export default __webpack_public_path__ + "static/media/suspendFacebook.c1ae2b57ed16a042e02fa71da6c5d16d.svg";
export { ForwardRef as ReactComponent };